// Uhrzeit zum Eintippen (19.10.2026, Simon): statt des Browser-Zeitfelds (Scrollrad, bei halber Eingabe leer) ein Textfeld, das
// „15“, „930“, „1530“, „15:30“ und „15.30“ versteht. Nach außen geht nur eine gültige Uhrzeit („HH:MM“) oder "" (leer).
// Während des Tippens bleibt der letzte gültige Wert stehen; beim Verlassen zeigt das Feld ihn sauber an.
import { useEffect, useState, type KeyboardEvent } from "react";

/** „15“, „930“, „1530“, „15:30“, „15.30“ → „15:30“; ungültig → null */
export function zeitLesen(roh: string): string | null {
  const t = roh.trim();
  const m = t.match(/^(\d{1,2})(?:[:.,h ]?(\d{2}))?$/) ?? t.match(/^(\d)(\d{2})$/);
  if (!m) return null;
  const std = Number(m[1]);
  const min = m[2] === undefined ? 0 : Number(m[2]);
  if (std > 23 || min > 59) return null;
  return `${String(std).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
}

interface Props {
  wert: string;
  onChange: (zeit: string) => void;
  /** Enter mit gültiger Uhrzeit (sonst greift ein umgebendes Formular wie gewohnt) */
  onEnter?: (zeit: string) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
  ariaLabel?: string;
  title?: string;
  autoFocus?: boolean;
}

export function ZeitFeld({ wert, onChange, onEnter, onKeyDown, className = "eingabe", ariaLabel = "Uhrzeit", title, autoFocus }: Props) {
  const [text, setText] = useState(wert);
  const [fokus, setFokus] = useState(false);
  useEffect(() => {
    if (!fokus) setText(wert);
  }, [wert, fokus]);
  const gueltig = zeitLesen(text);
  const fehler = text.trim() !== "" && gueltig === null;
  return (
    <input
      className={`${className}${fehler ? " eingabe--fehler" : ""}`}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      placeholder="hh:mm"
      size={6}
      value={text}
      autoFocus={autoFocus}
      aria-label={ariaLabel}
      aria-invalid={fehler}
      title={title ?? "Uhrzeit eintippen, z. B. 15 oder 15:30"}
      onFocus={(e) => {
        setFokus(true);
        e.currentTarget.select();
      }}
      onBlur={() => {
        setFokus(false);
        setText(gueltig ?? (text.trim() === "" ? "" : wert));
      }}
      onChange={(e) => {
        const neu = e.target.value;
        setText(neu);
        const z = zeitLesen(neu);
        if (z) onChange(z);
        else if (neu.trim() === "") onChange("");
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" && gueltig && onEnter) {
          e.preventDefault();
          onChange(gueltig);
          onEnter(gueltig);
          return;
        }
        onKeyDown?.(e);
      }}
    />
  );
}
